
import React from 'react';

class HolaMundo extends React.Component {
  constructor(props) {
    super(props);
  };

render (){
return (
    <div>
        <h2>Ok</h2>
     </div>
    );
}
}

export default HolaMundo;